/* global  */ // tUrl等のグローバル変数を宣言する
// import './_smoothScroll' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  $(window).on('resize', function() {
    //Facebook Page Plugin自動リサイズ
    const htmlStr = $('#pageplugin').html()
    let winWid = $(window).width()
    let timer = null
    var resWid = $(window).width()
    if (winWid !== resWid && resWid < 500) {
      clearTimeout(timer)
      timer = setTimeout(function() {
        $('#pageplugin').html(htmlStr)
        window.FB.XFBML.parse()
        winWid = $(window).width()
      }, 500)
    }
  })
})
